import { breadcrumb } from './breadcrumb';
import { service_package } from './service-package';
import { media } from './media';
import { number } from './number';
import { phone_lists } from './phone-list';
import { time_condition } from './time-condition';
import { group } from './group';
import { worksheet } from './worksheet';
import { queue } from './queue';
import { contact } from './contact';
import { contact_method } from './contact-method';
import { sip_account } from './sip-account';
import { stat } from './stat';
import { setting } from './setting';

export const pbx = {
  breadcrumb,
  media,
  number,
  group,
  contact,
  worksheet,
  queue,
  stat,
  'phone-list': phone_lists,
  'contact-method': contact_method,
  'service-package': service_package,
  'sip-account': sip_account,
  'time-condition': time_condition,
  setting
};
